const ELEMENT_TYPE_LABELS: Record<string, string> = {
  trafostation: 'Trafostation',
  hausanschluss: 'Hausanschluss',
  muffe: 'Muffe',
  kabelverteilschrank: 'KVS',
  bus: 'Knoten',
  line: 'Kabel',
  abgangsleitung: 'Kabel',
};

/** Returns a human-readable German label for the given element type. */
export function getElementTypeLabel(elementType: string | null | undefined): string | null {
  if (!elementType) return null;
  return ELEMENT_TYPE_LABELS[elementType.toLowerCase()] ?? elementType;
}

/** Formats "ElementType ElementName" for display, e.g. "Hausanschluss HA_123". */
export function formatElementInfo(elementType?: string | null, elementName?: string | null): string | null {
  const label = getElementTypeLabel(elementType);
  if (!label && !elementName) return null;
  if (!label) return elementName!;
  if (!elementName) return label;
  return `${label} ${elementName}`;
}
